import React, { useMemo, useEffect, useState } from "react";
import PageContainer from "../../components/PageContainer/PageContainer";
import styled from "styled-components";
import Footer from "../../components/Footer";
import { TOKEN_SYMBOL, RoomProperties, MISTERY_BOX_ADDRESS } from "../../utils/constants";
import "./leaderboardpage.css";
import { useMediaQuery } from "@mui/material";
import { notifySuccess } from "../../hooks/utils";
import { useTranslation } from "react-i18next";

const LeaderboardPage = () => {
    const { t, i18n } = useTranslation();
    const [leaderboardData, setLeaderboardData] = useState<any[]>([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [sortKey, setSortKey] = useState<keyof typeof leaderboardData[0] | null>("hashrate");
    const [sortDirection, setSortDirection] = useState<"asc" | "desc">("desc");


    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const res = await fetch("https://api.milkit.finance/leaderboard");
                const json = await res.json();

                // filter out players with address: Mistery_BOX_ADDRESS
                const filteredData = json.filter((player: any) => player.address !== MISTERY_BOX_ADDRESS);

                setLeaderboardData(filteredData);
            } catch (err) {
                console.error("Failed to fetch leaderboard:", err);
            }
        };

        fetchLeaderboard();
    }, []);

    const filteredAndSorted = useMemo(() => {
        const filtered = leaderboardData.filter((player) =>
            player.address.toLowerCase().includes(searchTerm)
        );

        if (!sortKey) return filtered;

        return [...filtered].sort((a, b) => {
            const aVal = a[sortKey];
            const bVal = b[sortKey];
            if (typeof aVal === "number" && typeof bVal === "number") {
                return sortDirection === "asc" ? aVal - bVal : bVal - aVal;
            }
            return 0;
        });
    }, [leaderboardData, searchTerm, sortKey, sortDirection]);

    function handleSort(key: keyof typeof leaderboardData[0]) {
        if (sortKey === key) {
            setSortDirection(sortDirection === "asc" ? "desc" : "asc");
        } else {
            setSortKey(key);
            setSortDirection("desc");
        }
    }




    const isSmallScreen = useMediaQuery('(max-width: 1160px)');


    // onclick function to copy the wallet address to clipboard
    const copyToClipboard = (address: string) => {
        navigator.clipboard.writeText(address).then(() => {
            notifySuccess("Wallet address copied to clipboard!");
        }).catch((err) => {
            console.error("Failed to copy: ", err);
        });
    };


    return (
        <PageContainer>
            <main style={{
                minHeight: '100vh',
                color: '#fff',
                fontFamily: "Press Start 2P, monospace"
            }}>
                <div style={{ marginTop: "50px", padding: "0 2rem" }}>
                    <h2 style={{
                        fontFamily: "Press Start 2P, monospace",
                        color: "#fff",
                        fontSize: "1.5rem",
                        marginBottom: "2rem",
                        textAlign: "center"
                    }}>{t("leaderboard.title")}</h2>

                    <div style={{ overflowX: "auto" }}>
                        <div style={{ marginBottom: "1rem", textAlign: "center" }}>
                            <input
                                type="text"
                                placeholder={t("leaderboard.search_placeholder")}
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                                style={{
                                    padding: "8px 12px",
                                    borderRadius: "0px",
                                    border: "3px solid #68949B",
                                    fontFamily: "monospace",
                                    fontSize: "0.8rem",
                                    background: "rgb(26, 61, 79)",
                                    color: "white"
                                }}
                            />
                        </div>

                        <table style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            fontFamily: "Press Start 2P, monospace",
                            fontSize: "0.7rem",
                            color: "white",
                            border: "4px solid #507c83",
                            background: "rgb(16, 44, 57)"
                        }}>
                            <thead>
                                <tr style={{ borderBottom: "2px solid #68949Baa" }}>
                                    <th style={{ padding: "0.5rem" }}>#</th>
                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("facilityLevel")}
                                    >
                                        {t("barn_level")} {sortKey === "facilityLevel" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th style={{ padding: "0.5rem" }}>Address</th>

                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("hashrate")}
                                    >
                                        {t("milk_power")} {sortKey === "hashrate" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>

                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("minersOwned")}
                                    >
                                        {t("total_animals")} {sortKey === "minersOwned" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>

                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("buys")}
                                    >
                                        {t("animals_bought")} {sortKey === "buys" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>

                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("sells")}
                                    >
                                        {t("animals_sold")} {sortKey === "sells" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>

                                    <th
                                        style={{ padding: "0.5rem", cursor: "pointer" }}
                                        onClick={() => handleSort("totalSpent")}
                                    >
                                        ${TOKEN_SYMBOL} {t("spent")} {sortKey === "totalSpent" ? (sortDirection === "asc" ? "↑" : "↓") : ""}
                                    </th>
                                    <th
                                        style={{ padding: "0.5rem" }}
                                    >
                                        
                                    </th>
                                </tr>
                            </thead>

                            <tbody>
                                {filteredAndSorted.map((player, index) => (
                                    <tr key={player.address} style={{ borderBottom: "1px solid #444" }}>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{index + 1}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" }}><img src={RoomProperties[player.facilityLevel].img} width={32} height={32} alt="barn level" />&nbsp;{RoomProperties[player.facilityLevel].name}</td>
                                        <td style={{ padding: "0.5rem", maxWidth: 150, overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }} onClick={() => copyToClipboard(player.address)}>
                                            {player.address.slice(0, 6)}...{player.address.slice(-4)}
                                        </td>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{player.hashrate}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{player.minersOwned}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{player.buys}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{player.sells}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center" }}>{player.totalSpent}</td>
                                        <td style={{ padding: "0.5rem", textAlign: "center", cursor: "pointer" }} onClick={() => window.open(`/farms/${player.address}`)}>View Barn</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

            </main>
            <Footer />
        </PageContainer>
    );
}

export default LeaderboardPage;
